// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__Vw0Tj","dragIcon":"SortableItem_dragIcon__2W8lt","disabled":"SortableItem_disabled__3b2ne"};